/*
Scratch MQTT Extension
(Message Clear Version)
*/

const ArgumentType = require('../../extension-support/argument-type');
const BlockType = require('../../extension-support/block-type');
const formatMessage = require('format-message');

const {
    Form_Name,
    Form_disconnect,
    Form_isconnect,
    Form_Connect,
    Form_Auto_Connect,
    Form_Connect_off,
    Form_Subscribe_Topic,
    Form_Publish_Topic,
    Form_FormDmqttMsg,
    Form_FormDmqttTopic,
    Form_getConnectState,
    Form_ClearMsg,
    Form_Unsubscribe_Topic
} = require('./translation');

let mqtt = require('mqtt/dist/mqtt');

// ======================
// Global
// ======================

let theLocale = null;

let client = {};
let clientId = '';

let mqtt_message = '';
let mqtt_topic = '';

// ======================
// Class
// ======================

class Scratch3Mqtt {

    constructor(runtime) {
        theLocale = this._setLocale();
        this.runtime = runtime;
    }

    _setLocale() {

        switch (formatMessage.setup().locale) {
            case 'ko':
                return 'ko';
            default:
                return 'en';
        }
    }

    // ======================
    // Blocks
    // ======================

    getInfo() {

        theLocale = this._setLocale();
        return {
            id: 'smartLink',
            color1: '#8E52EC',
            color2: '#9e36b3',
            color3: '#6a127c',
            name: Form_Name[theLocale],
            blockIconURI: 'data:image/png;base64,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',
            blocks: [



                // AUTO CONNECT
                {
                    opcode: 'auto_connect_mqtt',
                    blockType: BlockType.COMMAND,
                    text: Form_Auto_Connect[theLocale],
                    arguments: {
                    }
                },

                // DISCONNECT
                {
                    opcode: 'connect_off',
                    blockType: BlockType.COMMAND,
                    text: Form_Connect_off[theLocale],
                },

                // CONNECT STATE
                {
                    opcode: 'getConnectState',
                    blockType: BlockType.REPORTER,
                    text: Form_getConnectState[theLocale],
                },

                // SUBSCRIBE
                {
                    opcode: 'subscribe_topic',
                    blockType: BlockType.COMMAND,
                    text: Form_Subscribe_Topic[theLocale],
                    arguments: {
                        TOPIC: {
                            type: ArgumentType.STRING,
                            defaultValue: 'zumi01',
                        }
                    }
                },

                // 구독 해제
                {
                    opcode: 'unsubscribe_topic',

                    blockType: BlockType.COMMAND,

                    text: Form_Unsubscribe_Topic[theLocale],

                    arguments: {

                        TOPIC: {
                            type: ArgumentType.STRING,
                            defaultValue: 'zumi01',
                        }
                    }
                },

                // PUBLISH
                {
                    opcode: 'publish_topic',
                    blockType: BlockType.COMMAND,
                    text: Form_Publish_Topic[theLocale],
                    arguments: {
                        TOPIC: {
                            type: ArgumentType.STRING,
                            defaultValue: 'zumi02',
                        },
                        PUBLISH: {
                            type: ArgumentType.STRING,
                            defaultValue: 'Hello',
                        }
                    }
                },

                // MESSAGE
                {
                    opcode: 'mqtt_msg',
                    blockType: BlockType.REPORTER,
                    text: Form_FormDmqttMsg[theLocale],
                },

                // TOPIC
                {
                    opcode: 'mqtt_tpc',
                    blockType: BlockType.REPORTER,
                    text: Form_FormDmqttTopic[theLocale],
                },

                // CLEAR MESSAGE
                {
                    opcode: 'mqtt_clear',
                    blockType: BlockType.COMMAND,
                    text: Form_ClearMsg[theLocale],
                },

                '---',

                // CONNECT
                {
                    opcode: 'connect_mqtt',
                    blockType: BlockType.COMMAND,
                    text: Form_Connect[theLocale],
                    arguments: {
                        URL: {
                            type: ArgumentType.STRING,
                            defaultValue: 'wss://broker.emqx.io:8084/mqtt',
                        },
                        USR: {
                            type: ArgumentType.STRING,
                            defaultValue: ' ',
                        },
                        PWS: {
                            type: ArgumentType.STRING,
                            defaultValue: ' ',
                        }
                    }
                },


            ]
        };
    }

    // ======================
    // CONNECT
    // ======================

    async connect_mqtt(args) {

        if (client && client.connected) {
            console.log('already connected');
            return;
        }

        clientId = 'mqttx_' + Math.random().toString(16).substr(2, 8);

        const url = args.URL;
        const usr = args.USR;
        const pws = args.PWS;

        let options = {
            keepalive: 30,
            clientId: clientId,
            protocolId: 'MQTT',
            protocolVersion: 4,
            clean: true,
            reconnectPeriod: 1000,
            connectTimeout: 30000,
        };

        if (usr && usr !== ' ') {
            options.username = usr;
            options.password = pws;
        }

        client = mqtt.connect(url, options);

        // CONNECT
        client.on('connect', () => {
            console.log('MQTT connected:', clientId);
            // mqtt_message = Form_isconnect[theLocale];
        });

        // MESSAGE
        client.on('message', (topic, message) => {
            mqtt_message = message.toString();
            mqtt_topic = topic;
            console.log('Received:', mqtt_message);
        });

        // ERROR
        client.on('error', (err) => {
            console.error(err);
            //  mqtt_message = String(err);
        });

        // CLOSE

        client.on('close', () => {
            console.log('MQTT closed');
            //  mqtt_message = Form_disconnect[theLocale];
        });
    }

    async auto_connect_mqtt(args) {

        if (client && client.connected) {
            console.log('already connected');
            return;
        }

        clientId = 'mqttx_' + Math.random().toString(16).substr(2, 8);

        const url = 'wss://broker.emqx.io:8084/mqtt';

        let options = {
            keepalive: 30,
            clientId: clientId,
            protocolId: 'MQTT',
            protocolVersion: 4,
            clean: true,
            reconnectPeriod: 1000,
            connectTimeout: 30000,
        };

        client = mqtt.connect(url, options);

        client.on('connect', () => {
            console.log('MQTT connected:', clientId);
        });

        client.on('message', (topic, message) => {
            mqtt_message = message.toString();
            mqtt_topic = topic;
            console.log('Received:', mqtt_message);
        });

        client.on('error', (err) => {
            console.error(err);
        });

        client.on('close', () => {
            console.log('MQTT closed');
        });
    }
    // ======================
    // SUBSCRIBE
    // ======================

    async subscribe_topic(args) {
        const topic = args.TOPIC;
        if (!client || !client.subscribe) {
            return;
        }

        client.subscribe(topic, { qos: 0 });
        mqtt_topic = topic;
    }

    // ======================
    // PUBLISH
    // ======================

    async publish_topic(args) {
        if (!client || !client.publish) {
            return;
        }

        client.publish(
            args.TOPIC,
            args.PUBLISH,
            {
                qos: 0,
                retain: false
            }
        );
    }

    // 구독 해제
    async unsubscribe_topic(args) {
        const topic = args.TOPIC;
        if (!client || !client.unsubscribe) {
            return;
        }
        client.unsubscribe(topic);
        console.log('unsubscribe:', topic);
    }



    // ======================
    // MESSAGE
    // ======================

    mqtt_msg() {
        return mqtt_message;
    }

    // ======================
    // TOPIC
    // ======================

    mqtt_tpc() {
        return mqtt_topic;
    }

    // ======================
    // CLEAR
    // ======================

    mqtt_clear() {
        mqtt_message = '';
        mqtt_topic = '';
    }

    // ======================
    // DISCONNECT
    // ======================

    async connect_off() {
        // mqtt_message = Form_disconnect[theLocale];
        mqtt_topic = '';
        if (client && client.end) {
            client.end();
        }
        client = {};
    }

    // ======================
    // STATE
    // ======================

    getConnectState() {
        if (client && client.connected) {
            return Form_isconnect[theLocale];
        } else {
            return Form_disconnect[theLocale];
        }
    }
}

module.exports = Scratch3Mqtt;